import { mapState } from 'vuex';
import sumBy from 'lodash/sumBy';
export default {
  name: 'MediaUploadMultiple',
  props: {},
  data() {
    return {
      urls: [],
      files: [],
      responsive: false,
      responsiveInput: false,
      bytes: 10485760 // 10MB
    };
  },
  computed: {
    ...mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color'])
  },
  methods: {
    handleFileUpload(files) {
      if (files && files.length) {
        let urls = [];
        this.files = files;
        files.forEach(file => {
          if (file.type.match('image')) {
            let reader = new FileReader();
            reader.addEventListener('load', function (event) {
              var result = event.target.result;
              urls.push(result);
            });
            reader.readAsDataURL(file);
          }
        });
        this.urls = urls;
        this.$emit('upload-files', files);
      }
    },
    clear() {
      this.files = [];
      this.urls = [];
      this.$emit('clear-files');
    },
    sum(objects) {
      return sumBy(objects, o => o.size);
    },
    deleteFromList(index) {
      this.urls.splice(index, 1);
      this.files.splice(index, 1);
      this.$emit('upload-files', this.files);
    }
  }
};